import { useGlobalState, useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';

export const useESDefaultBannerCopy = () => {
  const { isLoggedIn } = useGlobalState();
  const { notificationTranslation } = useMyParcelsContext();
  const { get: getAnonymous, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const fallback = {
    mainTextDesktop: notificationTranslation.emailSyncDesktopMainText ?? '',
    mainTextMobile: notificationTranslation.emailSyncMobileMainText ?? '',
    buttonText: notificationTranslation.emailSyncButtonText ?? '',
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const get = isLoggedIn ? getSignedIn : getAnonymous;

  return {
    mainTextDesktop: get('email_sync_main_text_desktop', fallback.mainTextDesktop),
    mainTextMobile: get('email_sync_main_text_mobile', fallback.mainTextMobile),
    buttonText: get('email_sync_button_text', fallback.buttonText),
  };
};
